import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import SecondLevel from '@/components/secondLevel'



const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    redirect: "/china/261",
    children: [
      {
        path: '/', name: "中国钱币", component: SecondLevel, redirect: '/china/261',
        children: [
          { path: "/china/:id", name: "世界各地列表页", component: () => import('../components/common/List.vue'), meta: { title: "首页" } }
        ]
      },
      // { path: '/news', name: '最新参考', component:  SecondLevel, redirect: '/news',
      //   children: [
      //     { path: "/metalPrice", name: "世界金属价格", component:  () => import('../views/news/MetalPrice.vue') ,meta:{title:"世界金属价格"} },
      //     { path: "/worldExchange", name: "世界汇率", component:  () => import('../views/news/WorldExchange.vue') ,meta:{title:"世界汇率"} },
      //     { path: "/chineseNewCurrency", name: "中国新币发行情况", component:  () => import('../views/news/ChineseNewCurrency.vue') ,meta:{title:"中国新币发行情况"} },
      //   ]
      // },
      // { path: '/more', name: '学习更多', component:  SecondLevel, redirect: '/more', 
      //   children: [
      //     { path: "/majorMints", name: "目前世界主要铸币厂", component:  () => import('../views/more/MajorMints.vue') ,meta:{title:"目前世界主要铸币厂"} },
      //     { path: "/historyOfRMB", name: "人民币发展史", component:  () => import('../views/more/HistoryOfRMB.vue'),meta:{title:"人民币发展史"}  },
      //     { path: "/historyOfDecimal", name: "世界十进制货币改革史", component:  () => import('../views/more/HistoryOfDecimal.vue'),meta:{title:"世界十进制货币改革史"}  },
      //     { path: "/guideOfCoins", name: "钱币的保存指南", component:  () => import('../views/more/GuideOfCoins.vue') ,meta:{title:"钱币的保存指南"} },
      //     { path: "/goldStandard", name: "金本位的历程", component:  () => import('../views/more/GoldStandard.vue'),meta:{title:"金本位的历程"}  },
      //     { path: "/historyOfHKDollar", name: "港币历史", component:  () => import('../views/more/HistoryOfHKDollar.vue') ,meta:{title:"港币历史"} },
      //     { path: "/historyOfMopDollar", name: "澳门币历史", component:  () => import('../views/more/HistoryOfMopDollar.vue') ,meta:{title:"澳门币历史"} },
      //     { path: "/historyOfTaiDollar", name: "新台币历史", component:  () => import('../views/more/HistoryOfTaiDollar.vue'),meta:{title:"新台币历史"}  },

      //   ] },
    ]
  },
  {
    path: '/zg',
    name: 'Country',
    redirect: "/zg/country",
    component: () => import('../views/Country.vue'),
    children: [
      {
        path: '/zg/country', name: "中国钱币", component: SecondLevel, redirect: '/china/261',
        children: [
          { path: "/china/:id", name: "中国钱币列表页", component: () => import('../components/common/List.vue'), meta: { title: "中国钱币列表页" } },
        ]
      }
    ]
  },
  {
    path: '/overseas',
    name: 'Overseas',
    redirect: "/overseas/country",
    component: () => import('../views/Overseas.vue'),
    children: [
      {
        path: '/overseas/country', name: "外国钱币", component: SecondLevel, redirect: '/oversea/7',
        children: [
          { path: "/oversea/:id", name: "外国钱币列表页", component: () => import('../components/common/List.vue'), meta: { title: "外国钱币列表页" } },
        ]
      }
    ]
  },
  {
    path: '/about',
    name: 'About',
    component: () => import('../views/About.vue'),
    meta: { title: "关于我们" }
  },
  {
    path: '/culture',
    name: 'Culture',
    component: () => import('../views/Culture.vue'),
    meta: { title: "文化视野" }
  },
  {
    path: '/bbs',
    name: 'BBS',
    component: () => import('../views/BBS.vue'),
    meta: { title: "讨论社区" }
  },
  {
    path: '/use',
    name: 'Use',
    component: () => import('../views/Use.vue'),
    meta: { title: "使用指南" }
  },
  {
    path: '/feedback',
    name: 'Feedback',
    component: () => import('../views/Feedback.vue'),
    meta: { title: "用户反馈" }
  },
  {
    path: '/info/:id',
    name: 'Info',
    component: () => import('../views/Info.vue'),
    meta: { title: "详情页" }
  },
  {
    path: '/search',
    name: 'Search',
    component: () => import('../views/Search.vue'),
    meta: { title: "搜索结果页" }
  },
  { 
    path: "/majorMints", 
    name: "目前世界主要铸币厂", 
    component: () => import('../views/more/MajorMints.vue'), 
    meta: { title: "目前世界主要铸币厂" } 
  },
  { 
    path: "/historyOfRMB", 
    name: "人民币硬币发展史", 
    component: () => import('../views/more/HistoryOfRMB.vue'), 
    meta: { title: "人民币发展史" } 
  },
  { 
    path: "/aboutGrade", 
    name: "有关硬币品相等级的概述", 
    component: () => import('../views/more/AboutGrade.vue'), 
    meta: { title: "有关硬币品相等级的概述" } 
  },
  { 
    path: "/historyOfDecimal", 
    name: "世界十进制货币改革史", 
    component: () => import('../views/more/HistoryOfDecimal.vue'), 
    meta: { title: "世界十进制货币改革史" } 
  },
  { 
    path: "/guideOfCoins", 
    name: "钱币的保存指南", 
    component: () => import('../views/more/GuideOfCoins.vue'), 
    meta: { title: "钱币的保存指南" } 
  },
  { 
    path: "/worldWebSite", 
    name: "世界各国铸币厂及其网址", 
    component: () => import('../views/more/WorldWebSite.vue'), 
    meta: { title: "世界各国铸币厂及其网址" } 
  },
  { 
    path: "/goldStandard", 
    name: "金本位的历程", 
    component: () => import('../views/more/GoldStandard.vue'), 
    meta: { title: "金本位的历程" } 
  },
  { 
    path: "/historyOfHKDollar", 
    name: "香港硬币发展概述", 
    component: () => import('../views/more/HistoryOfHKDollar.vue'), 
    meta: { title: "香港硬币发展概述" } 
  },
  { path: "/historyOfMopDollar", name: "澳门币历史", component: () => import('../views/more/HistoryOfMopDollar.vue'), meta: { title: "澳门币历史" } },
  { path: "/historyOfTaiDollar", name: "新台币历史", component: () => import('../views/more/HistoryOfTaiDollar.vue'), meta: { title: "新台币历史" } },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
